export const ROOM__NO_ROOM = "NoRoom";
export const ROOM__AUTOMATIC_ASSIGNMENT = "AutomaticAssignment";
export const ROOM__DEFAULT_ROOMS = [ROOM__NO_ROOM, ROOM__AUTOMATIC_ASSIGNMENT]